import { Box } from "@mui/material";

type Props = {
  src: string;
  "data-testid"?: string;
};

const VideoBox = ({ src, "data-testid": testId }: Props) => {
  return (
    <Box
      data-testid={testId}
      sx={{
        display: "flex",
        borderRadius: 2,
        overflow: "hidden",
      }}
    >
      <video
        src={src}
        controls
        style={{ display: "flex", flex: 1, width: 1, maxHeight: "512px" }}
      />
    </Box>
  );
};

export default VideoBox;
